<template>
    <v-data-table
        :headers="useHeaders"
        :items="secondaryServices"
        disable-sort
        density="compact"
        class="elevation-1 table-server"
        :items-per-page="-1"
        hide-default-footer
    >
        <template v-slot:item.name="{item}">
            {{ getSecondaryServicesName(item.secondaryServiceId) }}
        </template>
        <template v-slot:item.status="{item}">
            {{ getSecondaryServicesStatus(item.secondaryServiceId) ? t('active') : t('inactive') }}
        </template>
        <template v-slot:item.typeSearchResults="{item}">
            <v-checkbox
                v-model="item.typeSearchResults"
                hide-details
                density="compact"
                data-cy="type-search-results"
                :disabled="!getSecondaryServicesStatus(item.secondaryServiceId)"
                @update:model-value="resetTypeNotOffer(item)"
            />
        </template>
        <template v-slot:item.typeAlternalive="{item}">
            <v-checkbox
                v-model="item.typeAlternalive"
                hide-details
                density="compact"
                data-cy="type-alternative"
                :disabled="!getSecondaryServicesStatus(item.secondaryServiceId)"
                @update:model-value="resetTypeNotOffer(item)"
            />
        </template>
        <template v-slot:item.typeNotOffer="{item}">
            <v-checkbox
                v-model="item.typeNotOffer"
                hide-details
                density="compact"
                data-cy="type-not-offer"
                :disabled="!getSecondaryServicesStatus(item.secondaryServiceId)"
                @update:model-value="resetServiceTypes(item)"
            />
        </template>
    </v-data-table>
</template>

<script setup lang="ts">
    import {contractServiceType} from '~/utils/types/types'

    const secondaryServices = defineModel<any>()

    const localized = useLocalized()

    onMounted(async () => {
        if (supplierStore.contract.serviceType === contractServiceType.ownHotel) {
            if (!supplierStore.mealTypes.length) await supplierStore.loadHotelSecondaryServices()
        } else {
            if (!supplierStore.secondaryServices.length) await supplierStore.loadOwnProductSecondaryServices()
        }
    })

    const {t} = useI18n()

    const useSecondaryServices = computed(() => {
        if (supplierStore.contract.serviceType === contractServiceType.ownHotel) return supplierStore.mealTypes
        return supplierStore.secondaryServices
    })

    const useHeaders = computed(() => {
        return [
            {title: t('id'), value: 'secondaryServiceId', minWidth: '120px'},
            {title: t('name'), value: 'name', minWidth: '120px'},
            {title: t('status'), value: 'status', minWidth: '120px'},
            {title: t('offer_on_search_result'), value: 'typeSearchResults'},
            {title: t('offer_as_alternative'), value: 'typeAlternalive'},
            {title: t('not_available'), value: 'typeNotOffer'},
        ]
    })

    const getSecondaryServices = (secondaryServiceId: number) => {
        return useSecondaryServices.value.find(service => service.id === secondaryServiceId)
    }
    const getSecondaryServicesName = (secondaryServiceId: number) => {
        const service = getSecondaryServices(secondaryServiceId)
        if (!service) return ''
        return localized(service.name)
    }
    const getSecondaryServicesStatus = (secondaryServiceId: number) => {
        const service = getSecondaryServices(secondaryServiceId)
        if (!service) return false
        return service.active
    }

    const resetTypeNotOffer = service => {
        service.typeNotOffer = false
    }
    const resetServiceTypes = service => {
        service.typeAlternalive = false
        service.typeSearchResults = false
    }
</script>
